import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActionComponent } from 'src/app/general/components/action/action.component';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { OrdersComponent } from '../../components/orders/orders.component';
import { PageComponent } from '../../components/page/page.component';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { OrdersModel } from '../../components/orders/orders-model';
import { BackendService } from '../../services/backend.service';
import { NavigationService } from '../../services/navigation.service';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { LocationOrdersForLaterModel } from '../../components/orders/location-orders-for-later-model';

@Component({
  selector: 'app-location-orders-for-later-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    LocationHeaderComponent,
    OrdersComponent,
    ActionComponent
  ],
  templateUrl: './location-orders-for-later-page.component.html',
  styleUrls: ['./location-orders-for-later-page.component.css']
})
export class LocationOrdersForLaterPageComponent {
  locationId: string;
  locationOrdersForLaterModel: OrdersModel;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute,
      private backendService: BackendService,
      private navigationService: NavigationService) {
    this.locationId = '';
    this.locationOrdersForLaterModel = new LocationOrdersForLaterModel(this.locationId, this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.locationId = Util.safeString(pathParams.get('locationId'));
    this.locationOrdersForLaterModel = new LocationOrdersForLaterModel(this.locationId, this.backendService);
  }

  public goToLocationPage(): void {
    this.navigationService.goToLocationPage(this.locationId)
  }
}
